import type { EcosystemSearchItem } from '@/features/ecosystem/api/ecosystem-api'

const MAX_RESULTS = 8

export function filterEcosystemItems(
  items: EcosystemSearchItem[],
  query: string,
): EcosystemSearchItem[] {
  const q = query.trim().toLowerCase()
  if (q.length === 0) return []
  return items
    .filter(
      (item) => item.label.toLowerCase().includes(q) || item.sublabel.toLowerCase().includes(q),
    )
    .slice(0, MAX_RESULTS)
}
